module.exports = __webpack_public_path__ + "static/media/violinplay_mergeconflict.8a72197e.wav";